



// // src/pages/Projects/ProjectDetails.jsx
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   ArrowLeftIcon,
//   PlusIcon,
//   PencilIcon,
//   TrashIcon,
//   UsersIcon,
//   ChartBarIcon,
//   ClipboardDocumentListIcon,
//   CheckCircleIcon,
//   ClockIcon,
//   ExclamationTriangleIcon,
//   ArrowPathIcon,
//   DocumentTextIcon,
// } from '@heroicons/react/24/outline';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   Cell,  PieChart,         
//   Pie,               
// } from 'recharts';
// import api from '../../utils/api';

// const COLORS = ['#6366f1', '#8b5cf6', '#ec4899', '#f43f5e'];

// const statusColors = {
//   'Not Started': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
//   'In Progress': 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
//   'Awaiting Approval': 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
//   'Completed': 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
//   'Approved': 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
//   'Pending': 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
//   'Draft': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
//   'Active': 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
//   'Archived': 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300',
// };

// export default function ProjectDetails() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [project, setProject] = useState(null);
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [users, setUsers] = useState([]);

//   // Quick add forms
//   const [showMilestoneForm, setShowMilestoneForm] = useState(false);
//   const [showTaskForm, setShowTaskForm] = useState(false);

//   const [milestoneForm, setMilestoneForm] = useState({
//     name: '',
//     sequence_no: '',
//     planned_start: '',
//     planned_end: '',
//     approval_required: true,
//   });

//   const [taskForm, setTaskForm] = useState({
//     title: '',
//     description: '',
//     assigned_to: '',
//     priority: 'Medium',
//     due_date: '',
//     status: 'Pending',
//   });

//   useEffect(() => {
//     loadData();
//     loadUsers();
//   }, [id]);

//   const loadData = async () => {
//     try {
//       setLoading(true);

//       // Load basic project details
//       const { data: projectRes } = await api.get(`/projects/${id}`);
//       setProject(projectRes.project);

//       // Load dashboard-specific data (stats, approvals, activity)
//       const { data: dashRes } = await api.get(`/projects/${id}/dashboard`);
//       setDashboardData(dashRes);
//     } catch (err) {
//       console.error(err);
//       setError('Failed to load project details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadUsers = async () => {
//     try {
//       const { data } = await api.get('/users');
//       setUsers(data.users || []);
//     } catch (err) {
//       console.error('Failed to load users', err);
//     }
//   };

//   // Derived progress data for charts
//   const progressData = useMemo(() => {
//     if (!project) return [];
//     return [
//       { name: 'Milestones', value: project.milestone_progress || 0 },
//       { name: 'Tasks', value: project.task_progress || 0 },
//     ];
//   }, [project]);

//   const milestoneStatusData = useMemo(() => {
//     if (!project?.Milestones) return [];
//     const counts = {
//       'Not Started': 0,
//       'In Progress': 0,
//       'Awaiting Approval': 0,
//       'Completed': 0,
//     };
//     project.Milestones.forEach((m) => {
//       if (counts[m.status] !== undefined) counts[m.status]++;
//     });
//     return Object.entries(counts)
//       .filter(([_, value]) => value > 0)
//       .map(([name, value]) => ({ name, value }));
//   }, [project]);

//   const handleAddMilestone = async () => {
//     if (!milestoneForm.name.trim() || !milestoneForm.sequence_no) {
//       alert('Name and sequence number are required');
//       return;
//     }

//     try {
//       await api.post(`/projects/${id}/milestones`, milestoneForm);
//       setShowMilestoneForm(false);
//       setMilestoneForm({
//         name: '',
//         sequence_no: project?.Milestones?.length + 1 || 1,
//         planned_start: '',
//         planned_end: '',
//         approval_required: true,
//       });
//       loadData();
//     } catch (err) {
//       alert('Failed to create milestone');
//     }
//   };

//   const handleAddTask = async () => {
//   if (!taskForm.title.trim()) return alert('Task title is required');

//   try {
//     await api.post('/tasks', {
//       ...taskForm,
//       project_id: Number(id),
//       milestone_id: taskForm.milestone_id ? Number(taskForm.milestone_id) : null,
//     });

//     setShowTaskForm(false);
//     setTaskForm({ /* reset */ });
//     loadData(); // refresh everything
//   } catch (err) {
//     alert(err.response?.data?.message || 'Failed to create task');
//   }
// };

// const updateItemStatus = async (type, itemId, newStatus) => {
//   try {
//     const endpoint = type === 'milestone' ? `/milestones/${itemId}` : `/tasks/${itemId}`;
//     await api.put(endpoint, { status: newStatus });
    
//     // Force full project reload
//     await loadData();
    
//     // Optional: Show nice toast instead of alert
//     alert(`Task/Milestone status updated to "${newStatus}"!`);
//   } catch (err) {
//     console.error("Status update failed:", err.response?.data || err);
//     alert('Failed to update: ' + (err.response?.data?.message || 'Server error'));
//   }
// };
  
//   // const updateItemStatus = async (type, itemId, newStatus) => {
//   //   try {
//   //     const endpoint = type === 'milestone' ? `/milestones/${itemId}` : `/tasks/${itemId}`;
//   //     await api.put(`/projects/${project.id}/tasks/${itemId}`, { status: newStatus });
//   //     loadData();
//   //   } catch (err) {
//   //     alert('Failed to update status');
//   //   }
//   // };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
//       </div>
//     );
//   }

//   if (error || !project || !dashboardData) {
//     return (
//       <div className="min-h-screen flex items-center justify-center text-red-600 dark:text-red-400">
//         {error || 'Project not found'}
//       </div>
//     );
//   }

//   const {
//     name,
//     project_uid,
//     project_type,
//     status,
//     start_date,
//     expected_end_date,
//     overall_progress = 0,
//     milestone_progress = 0,
//     task_progress = 0,
//     total_milestones = 0,
//     completed_milestones = 0,
//     total_tasks = 0,
//     completed_tasks = 0,
//     ProjectTeams = [],
//     Milestones = [],
//     Tasks = [],
//   } = project;

//   const { stats, recentActivity } = dashboardData;

//   const taskChartData = [
//     { name: 'Overdue', value: stats.tasks.overdue, color: '#ef4444' },
//     { name: 'Due Today', value: stats.tasks.dueToday, color: '#f59e0b' },
//     { name: 'Upcoming', value: stats.tasks.upcoming, color: '#10b981' },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pb-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        
//         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8 gap-4">
//   {/* Left side: Back button + Project Title */}
//   <div className="flex items-center gap-4">
//     <button
//       onClick={() => navigate('/projects')}
//       className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
//     >
//       <ArrowLeftIcon className="w-6 h-6 text-gray-600 dark:text-gray-400" />
//     </button>

//     <div>
//       {/* Project title in orange */}
//       <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 dark:text-orange-500 tracking-tight">
//         {name}
//       </h1>

//       {/* Subtitle smaller & muted */}
//       <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 mt-1 font-medium">
//         {project_uid} • {project_type || 'Other'} • {status || 'Active'}
//       </p>
//     </div>
//   </div>

//   {/* Right side: Action Buttons – smaller size, black color */}
//   <div className="flex items-center gap-3 flex-wrap">
//     <button
//       onClick={() => setShowMilestoneForm(true)}
//       className="
//         flex items-center gap-2 
//         px-4 py-2.5 
//         bg-black hover:bg-gray-900 
//         text-white text-sm font-medium 
//         rounded-lg shadow-md 
//         transition-all duration-200 
//         hover:shadow-lg hover:scale-[1.02] active:scale-100
//       "
//     >
//       <PlusIcon className="w-4 h-4" />
//       Add Milestone
//     </button>

//     <button
//       onClick={() => setShowTaskForm(true)}
//       className="
//         flex items-center gap-2 
//         px-4 py-2.5 
//         bg-black hover:bg-gray-900 
//         text-white text-sm font-medium 
//         rounded-lg shadow-md 
//         transition-all duration-200 
//         hover:shadow-lg hover:scale-[1.02] active:scale-100
//       "
//     >
//       <PlusIcon className="w-4 h-4" />
//       Add Task
//     </button>
//   </div>
// </div>

       
// <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-10">
//   {/* Overall Progress */}
//   <StatCard
//     icon={<CheckCircleIcon className="h-8 w-8 text-emerald-600" />}
//     title="Overall Progress"
//     value={`${overall_progress || 0}%`}
//     // subtitle="Project health"
//     className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//   />

//   {/* Milestones */}
//   <StatCard
//     icon={<ClipboardDocumentListIcon className="h-8 w-8 text-blue-600" />}
//     title="Milestones"
//     value={`${completed_milestones || 0}/${total_milestones || 0}`}
//     subtitle={`${Math.round((completed_milestones / total_milestones) * 100 || 0)}% complete`}
//     className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//   />

//   {/* Tasks */}
//   <StatCard
//     icon={<ClockIcon className="h-8 w-8 text-amber-600" />}
//     title="Tasks"
//     value={total_tasks || 0}
//     subtitle={`${stats?.tasks?.overdue || 0} overdue`}
//     className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//   />

//   {/* Pending Approvals */}
//   <StatCard
//     icon={
//       <ExclamationTriangleIcon 
//         className={`h-8 w-8 ${stats?.pendingApprovals > 0 ? 'text-rose-600' : 'text-gray-600'}`} 
//       />
//     }
//     title="Pending Approvals"
//     value={stats?.pendingApprovals || 0}
//     subtitle={stats?.pendingApprovals > 0 ? "Action required" : "All clear"}
//     className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//   />
// </div>
        

//         <div className="bg-gray-50 dark:bg-gray-900 rounded-xl shadow-lg p-6 mb-10 border border-gray-200 dark:border-gray-700">
//   <h3 className="text-xl font-semibold mb-6 flex items-center gap-3 text-gray-900 dark:text-gray-100">
//     <UsersIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
//     Team Members ({ProjectTeams.length})
//   </h3>

//   {ProjectTeams.length === 0 ? (
//     <p className="text-gray-500 dark:text-gray-400 text-center py-8 font-medium">
//       No team members assigned yet
//     </p>
//   ) : (
//     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//       {ProjectTeams.map((member) => (
//         <div
//           key={member.id}
//           className="
//             flex items-center gap-4 
//             p-4 
//             bg-white dark:bg-gray-800 
//             hover:bg-orange-50 dark:hover:bg-orange-950/30 
//             rounded-xl 
//             border border-gray-200 dark:border-gray-700 
//             transition-all duration-200 
//             shadow-sm hover:shadow-md
//           "
//         >
//           {/* Avatar */}
//           <div className="
//             w-12 h-12 
//             rounded-full 
//             bg-orange-100 dark:bg-orange-900/40 
//             flex items-center justify-center 
//             text-xl font-bold 
//             text-orange-700 dark:text-orange-300
//             border border-orange-200 dark:border-orange-800/50
//             shadow-sm
//           ">
//             {member.member?.name?.charAt(0)?.toUpperCase() || '?'}
//           </div>

//           {/* Info */}
//           <div className="flex-1 min-w-0">
//             <p className="font-semibold text-gray-900 dark:text-gray-100 truncate">
//               {member.member?.name}
//             </p>
//             <p className="text-sm text-gray-600 dark:text-gray-400">
//               {member.role || 'Member'}
//             </p>
//             <p className="
//               text-xs font-medium mt-1 
//               text-gray-500 dark:text-gray-400 
//               uppercase tracking-wide
//             ">
//               {member.permission_level || '—'}
//             </p>
//           </div>

//           {/* Edit button (optional small orange accent) */}
//           <button
//             className="
//               text-orange-600 hover:text-orange-700 
//               dark:text-orange-400 dark:hover:text-orange-300 
//               transition-colors p-1 rounded-full hover:bg-orange-50 dark:hover:bg-orange-900/30
//             "
//             title="Edit member"
//           >
//             <PencilIcon className="w-4 h-4" />
//           </button>
//         </div>
//       ))}
//     </div>
//   )}
// </div>
// <div className="bg-white dark:bg-gray-900 rounded-xl shadow overflow-hidden mb-10 border border-gray-200 dark:border-gray-700">
//   {/* Header with dark gray background */}
//   <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center bg-gray-100 dark:bg-gray-800">
//     <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-gray-100">
//       <ClipboardDocumentListIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
//       Milestones ({total_milestones})
//     </h2>
//   </div>

//   <div className="overflow-x-auto">
//     <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
//       <thead className="bg-gray-50 dark:bg-gray-800/70">
//         <tr>
//           {/* <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Seq
//           </th> */}
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Name
//           </th>
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Planned Dates
//           </th>
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Status
//           </th>
//           <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Actions
//           </th>
//         </tr>
//       </thead>
//       <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
//         {Milestones.length === 0 ? (
//           <tr>
//             <td colSpan={5} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400 font-medium">
//               No milestones created yet
//             </td>
//           </tr>
//         ) : (
//           Milestones.map((m) => (
//             <tr 
//               key={m.id} 
//               className="hover:bg-orange-50/40 dark:hover:bg-orange-950/20 transition-colors duration-150"
//             >
//               {/* <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-100">
//                 {m.sequence_no}
//               </td> */}
//               <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
//                 {m.name}
//               </td>
//               <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
//                 {m.planned_start || '—'} → {m.planned_end || '—'}
//               </td>
//               <td className="px-6 py-4">
//                 <div className="flex items-center gap-3">
//                   {/* Status badge with orange theme */}
//                   <span
//                     className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                       m.status === 'Completed' 
//                         ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
//                         : m.status === 'In Progress' 
//                         ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300'
//                         : m.status === 'Awaiting Approval' 
//                         ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300'
//                         : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
//                     }`}
//                   >
//                     {m.status}
//                   </span>

//                   {/* Status select with orange focus */}
//                   <select
//                     value={m.status}
//                     onChange={(e) => updateItemStatus('milestone', m.id, e.target.value)}
//                     className="
//                       text-sm border border-gray-300 dark:border-gray-600 
//                       rounded px-3 py-1.5 
//                       bg-white dark:bg-gray-800 
//                       text-gray-900 dark:text-gray-100
//                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 focus:ring-opacity-50
//                       hover:border-orange-400 transition-colors
//                     "
//                   >
//                     <option>Not Started</option>
//                     <option>In Progress</option>
//                     <option>Awaiting Approval</option>
//                     <option>Completed</option>
//                   </select>
//                 </div>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
//                 <div className="flex items-center justify-center gap-4">
//                   <button 
//                     className="text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 transition-colors"
//                     title="Edit milestone"
//                   >
//                     <PencilIcon className="w-5 h-5" />
//                   </button>
//                   <button 
//                     className="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors"
//                     title="Delete milestone"
//                   >
//                     <TrashIcon className="w-5 h-5" />
//                   </button>
//                 </div>
//               </td>
//             </tr>
//           ))
//         )}
//       </tbody>
//     </table>
//   </div>
// </div>
//         {/* Tasks Section */}
//         {/* <div className="bg-white dark:bg-gray-800 rounded-xl shadow overflow-hidden border border-gray-200 dark:border-gray-700">
//           <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
//             <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-white">
//               <CheckCircleIcon className="w-6 h-6 text-green-500" />
//               Tasks ({total_tasks})
//             </h2>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
//               <thead className="bg-gray-50 dark:bg-gray-800/50">
//                 <tr>
//                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
//                     Title
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
//                     Assignee
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
//                     Priority
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
//                     Due Date
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
//                     Status
//                   </th>
//                   <th className="px-6 py-4 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
//                 {Tasks.length === 0 ? (
//                   <tr>
//                     <td colSpan={6} className="px-6 py-10 text-center text-gray-500 dark:text-gray-400">
//                       No tasks created yet
//                     </td>
//                   </tr>
//                 ) : (
//                   Tasks.map((t) => (
//                     <tr key={t.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/30">
//                       <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-white">
//                         {t.title}
//                       </td>
//                       <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
//                         {t.assignee?.name || 'Unassigned'}
//                       </td>
//                       <td className="px-6 py-4">
//                         <span
//                           className={`px-2.5 py-1 text-xs font-medium rounded-full ${
//                             t.priority === 'Urgent'
//                               ? 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300'
//                               : t.priority === 'High'
//                               ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300'
//                               : 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300'
//                           }`}
//                         >
//                           {t.priority}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
//                         {t.due_date || '—'}
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="flex items-center gap-3">
//                           <span
//                             className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${statusColors[t.status] || 'bg-gray-100 text-gray-800'}`}
//                           >
//                             {t.status}
//                           </span>
//                           <select
//                             value={t.status}
//                             onChange={(e) => updateItemStatus('task', t.id, e.target.value)}
//                             className="text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
//                           >
//                             <option>Pending</option>
//                             <option>In Progress</option>
//                             <option>Needs Approval</option>
//                             <option>Approved</option>
//                             <option>Completed</option>
//                           </select>
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
//                         <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 mr-3">
//                           <PencilIcon className="w-5 h-5 inline" />
//                         </button>
//                         <button className="text-red-600 hover:text-red-900 dark:text-red-400">
//                           <TrashIcon className="w-5 h-5 inline" />
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div> */}
// <div className="bg-white dark:bg-gray-900 rounded-xl shadow overflow-hidden border border-gray-200 dark:border-gray-700">
//   {/* Header with dark gray background */}
//   <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center bg-gray-100 dark:bg-gray-800">
//     <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-gray-100">
//       <CheckCircleIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
//       Tasks ({total_tasks})
//     </h2>
//   </div>

//   <div className="overflow-x-auto">
//     <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
//       <thead className="bg-gray-50 dark:bg-gray-800/70">
//         <tr>
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Title
//           </th>
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Assignee
//           </th>
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Priority
//           </th>
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Due Date
//           </th>
//           <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Status
//           </th>
//           <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//             Actions
//           </th>
//         </tr>
//       </thead>
//       <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
//         {Tasks.length === 0 ? (
//           <tr>
//             <td colSpan={6} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400 font-medium">
//               No tasks created yet
//             </td>
//           </tr>
//         ) : (
//           Tasks.map((t) => (
//             <tr
//               key={t.id}
//               className="hover:bg-orange-50/40 dark:hover:bg-orange-950/20 transition-colors duration-150"
//             >
//               <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
//                 {t.title}
//               </td>
//               <td className="px-6 py-4 text-sm text-gray-700 dark:text-gray-300">
//                 {t.assignee?.name || 'Unassigned'}
//               </td>
//               <td className="px-6 py-4">
//                 <span
//                   className={`px-2.5 py-1 text-xs font-medium rounded-full ${
//                     t.priority === 'Urgent'
//                       ? 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300'
//                       : t.priority === 'High'
//                       ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300'
//                       : t.priority === 'Medium'
//                       ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-300'
//                       : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
//                   }`}
//                 >
//                   {t.priority}
//                 </span>
//               </td>
//               <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
//                 {t.due_date || '—'}
//               </td>
//               <td className="px-6 py-4">
//                 <div className="flex items-center gap-3">
//                   {/* Status badge */}
//                   <span
//                     className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                       t.status === 'Completed'
//                         ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
//                         : t.status === 'In Progress'
//                         ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300'
//                         : t.status === 'Approved'
//                         ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300'
//                         : t.status === 'Needs Approval'
//                         ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300'
//                         : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
//                     }`}
//                   >
//                     {t.status}
//                   </span>

//                   {/* Status select */}
//                   <select
//                     value={t.status}
//                     onChange={(e) => updateItemStatus('task', t.id, e.target.value)}
//                     className="
//                       text-sm border border-gray-300 dark:border-gray-600 
//                       rounded px-3 py-1.5 
//                       bg-white dark:bg-gray-800 
//                       text-gray-900 dark:text-gray-100
//                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 focus:ring-opacity-50
//                       hover:border-orange-400 transition-colors
//                     "
//                   >
//                     <option>Pending</option>
//                     <option>In Progress</option>
//                     <option>Needs Approval</option>
//                     <option>Approved</option>
//                     <option>Completed</option>
//                   </select>
//                 </div>
//               </td>
//               <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
//                 <div className="flex items-center justify-center gap-4">
//                   <button
//                     className="text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 transition-colors"
//                     title="Edit task"
//                   >
//                     <PencilIcon className="w-5 h-5" />
//                   </button>
//                   <button
//                     className="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors"
//                     title="Delete task"
//                   >
//                     <TrashIcon className="w-5 h-5" />
//                   </button>
//                 </div>
//               </td>
//             </tr>
//           ))
//         )}
//       </tbody>
//     </table>
//   </div>
// </div>
//         {/* Quick Add Milestone Form - Modal style */}
//         {showMilestoneForm && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">
//                 Add New Milestone
//               </h3>

//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Milestone Name *
//                   </label>
//                   <input
//                     type="text"
//                     value={milestoneForm.name}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, name: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     placeholder="e.g. Design Phase Completion"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Sequence Number *
//                   </label>
//                   <input
//                     type="number"
//                     value={milestoneForm.sequence_no}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, sequence_no: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     min="1"
//                   />
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Planned Start
//                     </label>
//                     <input
//                       type="date"
//                       value={milestoneForm.planned_start}
//                       onChange={(e) =>
//                         setMilestoneForm({ ...milestoneForm, planned_start: e.target.value })
//                       }
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Planned End
//                     </label>
//                     <input
//                       type="date"
//                       value={milestoneForm.planned_end}
//                       onChange={(e) =>
//                         setMilestoneForm({ ...milestoneForm, planned_end: e.target.value })
//                       }
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex items-center">
//                   <input
//                     type="checkbox"
//                     checked={milestoneForm.approval_required}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, approval_required: e.target.checked })
//                     }
//                     className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
//                   />
//                   <label className="ml-2 text-sm text-gray-700 dark:text-gray-300">
//                     Requires Approval
//                   </label>
//                 </div>
//               </div>

//               <div className="mt-8 flex justify-end gap-3">
//                 <button
//                   onClick={() => setShowMilestoneForm(false)}
//                   className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleAddMilestone}
//                   className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg shadow-sm transition"
//                 >
//                   Create Milestone
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Quick Add Task Form - Modal style */}
//         {showTaskForm && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">Add New Task</h3>

//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Task Title *
//                   </label>
//                   <input
//                     type="text"
//                     value={taskForm.title}
//                     onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     placeholder="e.g. Create social media creatives for week 1"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Description
//                   </label>
//                   <textarea
//                     value={taskForm.description}
//                     onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
//                     rows={3}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Assign To
//                   </label>
//                   <select
//                     value={taskForm.assigned_to}
//                     onChange={(e) => setTaskForm({ ...taskForm, assigned_to: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                   >
//                     <option value="">Unassigned</option>
//                     {users.map((user) => (
//                       <option key={user.id} value={user.id}>
//                         {user.name} ({user.role?.name || 'Member'})
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Priority
//                     </label>
//                     <select
//                       value={taskForm.priority}
//                       onChange={(e) => setTaskForm({ ...taskForm, priority: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     >
//                       <option>Low</option>
//                       <option>Medium</option>
//                       <option>High</option>
//                       {/* <option>Urgent</option> */}
//                     </select>
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Due Date
//                     </label>
//                     <input
//                       type="date"
//                       value={taskForm.due_date}
//                       onChange={(e) => setTaskForm({ ...taskForm, due_date: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Initial Status
//                   </label>
//                   <select
//                     value={taskForm.status}
//                     onChange={(e) => setTaskForm({ ...taskForm, status: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                   >
//                     <option>Pending</option>
//                     <option>In Progress</option>
//                     <option>Needs Approval</option>
//                   </select>
//                 </div>
//               </div>
//               <div>
//           <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//             Assign to Milestone
//           </label>
//           <select
//             value={taskForm.milestone_id || ''}
//             onChange={(e) => setTaskForm({ ...taskForm, milestone_id: e.target.value || null })}
//             className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//           >
//             <option value="">— Unassigned / General —</option>
//             {project?.Milestones?.map(m => (
//               <option key={m.id} value={m.id}>
//                 {m.sequence_no}. {m.name} ({m.status})
//               </option>
//             ))}
//           </select>
//         </div>

//               <div className="mt-8 flex justify-end gap-3">
//                 <button
//                   onClick={() => setShowTaskForm(false)}
//                   className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleAddTask}
//                   className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg shadow-sm transition"
//                 >
//                   Create Task
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// // function StatCard({ icon, title, value, subtitle }) {
// //   return (
// //     <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow border border-gray-200 dark:border-gray-700">
// //       <div className="flex items-center gap-4">
// //         {icon}
// //         <div>
// //           <p className="text-sm text-gray-500 dark:text-gray-400">{title}</p>
// //           <p className="text-2xl font-bold">{value}</p>
// //           <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{subtitle}</p>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }
// function StatCard({ icon, title, value, subtitle, className = "" }) {
//   return (
//     <div 
//       className={`
//         rounded-xl shadow-sm border p-5 sm:p-6
//         transition-all duration-200 hover:shadow
//         ${className}
//       `}
//     >
//       <div className="flex items-center gap-4">
//         <div className="flex-shrink-0">{icon}</div>
//         <div className="min-w-0">
//           <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
//             {title}
//           </p>
//           <p className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mt-1">
//             {value}
//           </p>
//           <p className="text-sm text-gray-600 dark:text-gray-400 mt-1.5">
//             {subtitle}
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// // src/pages/Projects/ProjectDetails.jsx
// import React, { useState, useEffect, useMemo } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   ArrowLeftIcon,
//   PlusIcon,
//   PencilIcon,
//   TrashIcon,
//   UsersIcon,
//   ClipboardDocumentListIcon,
//   CheckCircleIcon,
//   ClockIcon,
//   ExclamationTriangleIcon,
// } from '@heroicons/react/24/outline';
// import api from '../../utils/api';

// const statusColors = {
//   'Not Started': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
//   'In Progress': 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
//   'Awaiting Approval': 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
//   'Completed': 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
//   'Approved': 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
//   'Pending': 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
//   'Draft': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
//   'Active': 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
//   'Archived': 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300',
// };

// export default function ProjectDetails() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [project, setProject] = useState(null);
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [users, setUsers] = useState([]);

//   // Add / Edit forms
//   const [showMilestoneForm, setShowMilestoneForm] = useState(false);
//   const [showEditMilestoneForm, setShowEditMilestoneForm] = useState(false);
//   const [editingMilestone, setEditingMilestone] = useState(null);

//   const [showTaskForm, setShowTaskForm] = useState(false);
//   const [showEditTaskForm, setShowEditTaskForm] = useState(false);
//   const [editingTask, setEditingTask] = useState(null);

//   const [showEditTeamMember, setShowEditTeamMember] = useState(false);
//   const [editingTeamMember, setEditingTeamMember] = useState(null);

//   // Form states
//   const [milestoneForm, setMilestoneForm] = useState({
//     name: '',
//     sequence_no: '',
//     planned_start: '',
//     planned_end: '',
//     approval_required: true,
//   });

//   const [taskForm, setTaskForm] = useState({
//     title: '',
//     description: '',
//     assigned_to: '',
//     priority: 'Medium',
//     due_date: '',
//     status: 'Pending',
//     milestone_id: '',
//   });

//   useEffect(() => {
//     loadData();
//     loadUsers();
//   }, [id]);

//   const loadData = async () => {
//     try {
//       setLoading(true);
//       const { data: projectRes } = await api.get(`/projects/${id}`);
//       setProject(projectRes.project);

//       const { data: dashRes } = await api.get(`/projects/${id}/dashboard`);
//       setDashboardData(dashRes);
//     } catch (err) {
//       console.error(err);
//       setError('Failed to load project details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadUsers = async () => {
//     try {
//       const { data } = await api.get('/users');
//       setUsers(data.users || []);
//     } catch (err) {
//       console.error('Failed to load users', err);
//     }
//   };
//  const updateItemStatus = async (type, itemId, newStatus) => {
//     try {
//       const endpoint = type === 'milestone' ? `/milestones/${itemId}` : `/tasks/${itemId}`;
//       await api.put(endpoint, { status: newStatus });
      
//       // Refresh the whole project data
//       await loadData();
      
//       // Optional: nicer feedback
//       alert(`Status updated to "${newStatus}"`);
//     } catch (err) {
//       console.error("Status update failed:", err);
//       alert('Failed to update status: ' + (err.response?.data?.message || 'Server error'));
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //   Milestone Handlers
//   // ──────────────────────────────────────────────────────────────

//   const handleAddMilestone = async () => {
//     if (!milestoneForm.name.trim() || !milestoneForm.sequence_no) {
//       alert('Name and sequence number are required');
//       return;
//     }

//     try {
//       await api.post(`/projects/${id}/milestones`, milestoneForm);
//       setShowMilestoneForm(false);
//       setMilestoneForm({
//         name: '',
//         sequence_no: project?.Milestones?.length + 2 || 1,
//         planned_start: '',
//         planned_end: '',
//         approval_required: true,
//       });
//       loadData();
//     } catch (err) {
//       alert('Failed to create milestone');
//     }
//   };

//   const handleEditMilestone = (milestone) => {
//     setEditingMilestone({ ...milestone });
//     setShowEditMilestoneForm(true);
//   };

//   const handleUpdateMilestone = async () => {
//     if (!editingMilestone.name.trim()) return alert('Name is required');

//     try {
//       await api.put(`/milestones/${editingMilestone.id}`, {
//         name: editingMilestone.name,
//         sequence_no: editingMilestone.sequence_no,
//         planned_start: editingMilestone.planned_start || null,
//         planned_end: editingMilestone.planned_end || null,
//         approval_required: editingMilestone.approval_required,
//       });
//       setShowEditMilestoneForm(false);
//       setEditingMilestone(null);
//       loadData();
//       alert('Milestone updated successfully');
//     } catch (err) {
//       alert('Failed to update milestone');
//     }
//   };

//   const handleDeleteMilestone = async (milestoneId) => {
//     if (!window.confirm('Delete this milestone?')) return;
//     try {
//       await api.delete(`/milestones/${milestoneId}`);
//       loadData();
//       alert('Milestone deleted');
//     } catch (err) {
//       alert('Failed to delete milestone');
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //   Task Handlers
//   // ──────────────────────────────────────────────────────────────

//   const handleAddTask = async () => {
//     if (!taskForm.title.trim()) return alert('Task title is required');

//     try {
//       await api.post('/tasks', {
//         ...taskForm,
//         project_id: Number(id),
//         milestone_id: taskForm.milestone_id ? Number(taskForm.milestone_id) : null,
//       });
//       setShowTaskForm(false);
//       setTaskForm({
//         title: '',
//         description: '',
//         assigned_to: '',
//         priority: 'Medium',
//         due_date: '',
//         status: 'Pending',
//         milestone_id: '',
//       });
//       loadData();
//     } catch (err) {
//       alert(err.response?.data?.message || 'Failed to create task');
//     }
//   };

//   const handleEditTask = (task) => {
//     setEditingTask({ ...task });
//     setShowEditTaskForm(true);
//   };

//   const handleUpdateTask = async () => {
//     if (!editingTask.title.trim()) return alert('Title is required');

//     try {
//       await api.put(`/tasks/${editingTask.id}`, {
//         title: editingTask.title,
//         description: editingTask.description,
//         assigned_to: editingTask.assigned_to || null,
//         priority: editingTask.priority,
//         due_date: editingTask.due_date || null,
//         status: editingTask.status,
//         milestone_id: editingTask.milestone_id || null,
//       });
//       setShowEditTaskForm(false);
//       setEditingTask(null);
//       loadData();
//       alert('Task updated successfully');
//     } catch (err) {
//       alert('Failed to update task');
//     }
//   };

//   const handleDeleteTask = async (taskId) => {
//     if (!window.confirm('Delete this task?')) return;
//     try {
//       await api.delete(`/tasks/${taskId}`);
//       loadData();
//       alert('Task deleted');
//     } catch (err) {
//       alert('Failed to delete task');
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //   Team Member Handlers
//   // ──────────────────────────────────────────────────────────────

//   const handleEditTeamMember = (member) => {
//     setEditingTeamMember({ ...member });
//     setShowEditTeamMember(true);
//   };

//   const handleUpdateTeamMember = async () => {
//     try {
//       await api.put(`/projects/${id}/team-members/${editingTeamMember.id}`, {
//         role: editingTeamMember.role,
//         permission_level: editingTeamMember.permission_level,
//       });
//       setShowEditTeamMember(false);
//       setEditingTeamMember(null);
//       loadData();
//       alert('Team member updated');
//     } catch (err) {
//       alert('Failed to update team member');
//     }
//   };

//   const handleDeleteTeamMember = async (teamMemberId) => {
//     if (!window.confirm('Remove this team member from the project?')) return;
//     try {
//       await api.delete(`/projects/${id}/team-members/${teamMemberId}`);
//       loadData();
//       alert('Team member removed');
//     } catch (err) {
//       alert('Failed to remove team member');
//     }
//   };

//   // ──────────────────────────────────────────────────────────────
//   //   Render
//   // ──────────────────────────────────────────────────────────────

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
//       </div>
//     );
//   }

//   if (error || !project || !dashboardData) {
//     return (
//       <div className="min-h-screen flex items-center justify-center text-red-600 dark:text-red-400">
//         {error || 'Project not found'}
//       </div>
//     );
//   }

//   const {
//     name,
//     project_uid,
//     project_type,
//     status,
//     start_date,
//     expected_end_date,
//     overall_progress = 0,
//     milestone_progress = 0,
//     task_progress = 0,
//     total_milestones = 0,
//     completed_milestones = 0,
//     total_tasks = 0,
//     completed_tasks = 0,
//     ProjectTeams = [],
//     Milestones = [],
//     Tasks = [],
//   } = project;

//   const { stats } = dashboardData;

//   return (
//     <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pb-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
//         {/* Header */}
//         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8 gap-4">
//           <div className="flex items-center gap-4">
//             <button
//               onClick={() => navigate('/projects')}
//               className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800 transition-colors"
//             >
//               <ArrowLeftIcon className="w-6 h-6 text-gray-600 dark:text-gray-400" />
//             </button>

//             <div>
//               <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 dark:text-orange-500 tracking-tight">
//                 {name}
//               </h1>
//               <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 mt-1 font-medium">
//                 {project_uid} • {project_type || 'Other'} • {status || 'Active'}
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3 flex-wrap">
//             <button
//               onClick={() => setShowMilestoneForm(true)}
//               className="flex items-center gap-2 px-4 py-2.5 bg-black hover:bg-gray-900 text-white text-sm font-medium rounded-lg shadow-md transition-all hover:shadow-lg hover:scale-[1.02]"
//             >
//               <PlusIcon className="w-4 h-4" />
//               Add Milestone
//             </button>

//             <button
//               onClick={() => setShowTaskForm(true)}
//               className="flex items-center gap-2 px-4 py-2.5 bg-black hover:bg-gray-900 text-white text-sm font-medium rounded-lg shadow-md transition-all hover:shadow-lg hover:scale-[1.02]"
//             >
//               <PlusIcon className="w-4 h-4" />
//               Add Task
//             </button>
//           </div>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-10">
//           <StatCard
//             icon={<CheckCircleIcon className="h-8 w-8 text-emerald-600" />}
//             title="Overall Progress"
//             value={`${overall_progress || 0}%`}
//             className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//           />

//           <StatCard
//             icon={<ClipboardDocumentListIcon className="h-8 w-8 text-blue-600" />}
//             title="Milestones"
//             value={`${completed_milestones || 0}/${total_milestones || 0}`}
//             subtitle={`${Math.round((completed_milestones / total_milestones) * 100 || 0)}% complete`}
//             className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//           />

//           <StatCard
//             icon={<ClockIcon className="h-8 w-8 text-amber-600" />}
//             title="Tasks"
//             value={total_tasks || 0}
//             subtitle={`${stats?.tasks?.overdue || 0} overdue`}
//             className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//           />

//           <StatCard
//             icon={
//               <ExclamationTriangleIcon 
//                 className={`h-8 w-8 ${stats?.pendingApprovals > 0 ? 'text-rose-600' : 'text-gray-600'}`} 
//               />
//             }
//             title="Pending Approvals"
//             value={stats?.pendingApprovals || 0}
//             subtitle={stats?.pendingApprovals > 0 ? "Action required" : "All clear"}
//             className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
//           />
//         </div>

//         {/* Team Members Section */}
//         <div className="bg-gray-50 dark:bg-gray-900 rounded-xl shadow-lg p-6 mb-10 border border-gray-200 dark:border-gray-700">
//           <h3 className="text-xl font-semibold mb-6 flex items-center gap-3 text-gray-900 dark:text-gray-100">
//             <UsersIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
//             Team Members ({ProjectTeams.length})
//           </h3>

//           {ProjectTeams.length === 0 ? (
//             <p className="text-gray-500 dark:text-gray-400 text-center py-8 font-medium">
//               No team members assigned yet
//             </p>
//           ) : (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//               {ProjectTeams.map((member) => (
//                 <div
//                   key={member.id}
//                   className="flex items-center gap-4 p-4 bg-white dark:bg-gray-800 hover:bg-orange-50 dark:hover:bg-orange-950/30 rounded-xl border border-gray-200 dark:border-gray-700 transition-all shadow-sm hover:shadow-md"
//                 >
//                   <div className="w-12 h-12 rounded-full bg-orange-100 dark:bg-orange-900/40 flex items-center justify-center text-xl font-bold text-orange-700 dark:text-orange-300 border border-orange-200 dark:border-orange-800/50 shadow-sm">
//                     {member.member?.name?.charAt(0)?.toUpperCase() || '?'}
//                   </div>

//                   <div className="flex-1 min-w-0">
//                     <p className="font-semibold text-gray-900 dark:text-gray-100 truncate">
//                       {member.member?.name}
//                     </p>
//                     <p className="text-sm text-gray-600 dark:text-gray-400">
//                       {member.role || 'Member'}
//                     </p>
//                     <p className="text-xs font-medium mt-1 text-gray-500 dark:text-gray-400 uppercase tracking-wide">
//                       {member.permission_level || '—'}
//                     </p>
//                   </div>

//                   <div className="flex gap-2">
//                     <button
//                       onClick={() => handleEditTeamMember(member)}
//                       className="text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 transition-colors p-1 rounded-full hover:bg-orange-50 dark:hover:bg-orange-900/30"
//                       title="Edit role / permission"
//                     >
//                       <PencilIcon className="w-5 h-5" />
//                     </button>
//                     <button
//                       onClick={() => handleDeleteTeamMember(member.id)}
//                       className="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors p-1 rounded-full hover:bg-red-50 dark:hover:bg-red-900/30"
//                       title="Remove from project"
//                     >
//                       <TrashIcon className="w-5 h-5" />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Milestones Section */}
//         <div className="bg-white dark:bg-gray-900 rounded-xl shadow overflow-hidden mb-10 border border-gray-200 dark:border-gray-700">
//           <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center bg-gray-100 dark:bg-gray-800">
//             <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-gray-100">
//               <ClipboardDocumentListIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
//               Milestones ({total_milestones})
//             </h2>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
//               <thead className="bg-gray-50 dark:bg-gray-800/70">
//                 <tr>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Name
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Planned Dates
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Status
//                   </th>
//                   <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
//                 {Milestones.length === 0 ? (
//                   <tr>
//                     <td colSpan={4} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400 font-medium">
//                       No milestones created yet
//                     </td>
//                   </tr>
//                 ) : (
//                   Milestones.map((m) => (
//                     <tr 
//                       key={m.id} 
//                       className="hover:bg-orange-50/40 dark:hover:bg-orange-950/20 transition-colors duration-150"
//                     >
//                       <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
//                         {m.name}
//                       </td>
//                       <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
//                         {m.planned_start || '—'} → {m.planned_end || '—'}
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="flex items-center gap-3">
//                           <span
//                             className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                               m.status === 'Completed' 
//                                 ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
//                                 : m.status === 'In Progress' 
//                                 ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300'
//                                 : m.status === 'Awaiting Approval' 
//                                 ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300'
//                                 : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
//                             }`}
//                           >
//                             {m.status}
//                           </span>

//                           <select
//                             value={m.status}
//                             onChange={(e) => updateItemStatus('milestone', m.id, e.target.value)}
//                             className="text-sm border border-gray-300 dark:border-gray-600 rounded px-3 py-1.5 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 focus:ring-opacity-50 hover:border-orange-400 transition-colors"
//                           >
//                             <option>Not Started</option>
//                             <option>In Progress</option>
//                             <option>Awaiting Approval</option>
//                             <option>Completed</option>
//                           </select>
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
//                         <div className="flex items-center justify-center gap-4">
//                           <button 
//                             onClick={() => handleEditMilestone(m)}
//                             className="text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 transition-colors"
//                             title="Edit milestone"
//                           >
//                             <PencilIcon className="w-5 h-5" />
//                           </button>
//                           <button 
//                             onClick={() => handleDeleteMilestone(m.id)}
//                             className="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors"
//                             title="Delete milestone"
//                           >
//                             <TrashIcon className="w-5 h-5" />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Tasks Section */}
//         <div className="bg-white dark:bg-gray-900 rounded-xl shadow overflow-hidden border border-gray-200 dark:border-gray-700">
//           <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center bg-gray-100 dark:bg-gray-800">
//             <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-gray-100">
//               <CheckCircleIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
//               Tasks ({total_tasks})
//             </h2>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
//               <thead className="bg-gray-50 dark:bg-gray-800/70">
//                 <tr>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Title
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Assignee
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Priority
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Due Date
//                   </th>
//                   <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Status
//                   </th>
//                   <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
//                 {Tasks.length === 0 ? (
//                   <tr>
//                     <td colSpan={6} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400 font-medium">
//                       No tasks created yet
//                     </td>
//                   </tr>
//                 ) : (
//                   Tasks.map((t) => (
//                     <tr
//                       key={t.id}
//                       className="hover:bg-orange-50/40 dark:hover:bg-orange-950/20 transition-colors duration-150"
//                     >
//                       <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
//                         {t.title}
//                       </td>
//                       <td className="px-6 py-4 text-sm text-gray-700 dark:text-gray-300">
//                         {t.assignee?.name || 'Unassigned'}
//                       </td>
//                       <td className="px-6 py-4">
//                         <span
//                           className={`px-2.5 py-1 text-xs font-medium rounded-full ${
//                             t.priority === 'Urgent'
//                               ? 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300'
//                               : t.priority === 'High'
//                               ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300'
//                               : t.priority === 'Medium'
//                               ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-300'
//                               : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
//                           }`}
//                         >
//                           {t.priority}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
//                         {t.due_date || '—'}
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="flex items-center gap-3">
//                           <span
//                             className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
//                               t.status === 'Completed'
//                                 ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
//                                 : t.status === 'In Progress'
//                                 ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300'
//                                 : t.status === 'Approved'
//                                 ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300'
//                                 : t.status === 'Needs Approval'
//                                 ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300'
//                                 : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
//                             }`}
//                           >
//                             {t.status}
//                           </span>

//                           <select
//                             value={t.status}
//                             onChange={(e) => updateItemStatus('task', t.id, e.target.value)}
//                             className="text-sm border border-gray-300 dark:border-gray-600 rounded px-3 py-1.5 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 focus:ring-opacity-50 hover:border-orange-400 transition-colors"
//                           >
//                             <option>Pending</option>
//                             <option>In Progress</option>
//                             <option>Needs Approval</option>
//                             <option>Approved</option>
//                             <option>Completed</option>
//                           </select>
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
//                         <div className="flex items-center justify-center gap-4">
//                           <button
//                             onClick={() => handleEditTask(t)}
//                             className="text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 transition-colors"
//                             title="Edit task"
//                           >
//                             <PencilIcon className="w-5 h-5" />
//                           </button>
//                           <button
//                             onClick={() => handleDeleteTask(t.id)}
//                             className="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors"
//                             title="Delete task"
//                           >
//                             <TrashIcon className="w-5 h-5" />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ──────────────────────────────────────────────────────────────
//             MODALS
//         ────────────────────────────────────────────────────────────── */}

//         {/* Add Milestone Modal */}
//         {showMilestoneForm && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">
//                 Add New Milestone
//               </h3>
//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Milestone Name *
//                   </label>
//                   <input
//                     type="text"
//                     value={milestoneForm.name}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, name: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     placeholder="e.g. Design Phase Completion"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Sequence Number *
//                   </label>
//                   <input
//                     type="number"
//                     value={milestoneForm.sequence_no}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, sequence_no: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     min="1"
//                   />
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Planned Start
//                     </label>
//                     <input
//                       type="date"
//                       value={milestoneForm.planned_start}
//                       onChange={(e) =>
//                         setMilestoneForm({ ...milestoneForm, planned_start: e.target.value })
//                       }
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Planned End
//                     </label>
//                     <input
//                       type="date"
//                       value={milestoneForm.planned_end}
//                       onChange={(e) =>
//                         setMilestoneForm({ ...milestoneForm, planned_end: e.target.value })
//                       }
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex items-center">
//                   <input
//                     type="checkbox"
//                     checked={milestoneForm.approval_required}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, approval_required: e.target.checked })
//                     }
//                     className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
//                   />
//                   <label className="ml-2 text-sm text-gray-700 dark:text-gray-300">
//                     Requires Approval
//                   </label>
//                 </div>
//               </div>

              
//               <div className="mt-8 flex justify-end gap-3">
//                 <button onClick={() => setShowMilestoneForm(false)} className="px-5 py-2.5 border rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100">
//                   Cancel
//                 </button>
//                 <button onClick={handleAddMilestone} className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg">
//                   Create Milestone
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Edit Milestone Modal */}
//         {showEditMilestoneForm && editingMilestone && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">
//                 Edit Milestone
//               </h3>

//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Name *</label>
//                   <input
//                     type="text"
//                     value={editingMilestone.name}
//                     onChange={(e) => setEditingMilestone({ ...editingMilestone, name: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium mb-1">Sequence Number *</label>
//                   <input
//                     type="number"
//                     value={editingMilestone.sequence_no}
//                     onChange={(e) => setEditingMilestone({ ...editingMilestone, sequence_no: Number(e.target.value) })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     min="1"
//                   />
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium mb-1">Planned Start</label>
//                     <input
//                       type="date"
//                       value={editingMilestone.planned_start || ''}
//                       onChange={(e) => setEditingMilestone({ ...editingMilestone, planned_start: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium mb-1">Planned End</label>
//                     <input
//                       type="date"
//                       value={editingMilestone.planned_end || ''}
//                       onChange={(e) => setEditingMilestone({ ...editingMilestone, planned_end: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex items-center">
//                   <input
//                     type="checkbox"
//                     checked={editingMilestone.approval_required}
//                     onChange={(e) => setEditingMilestone({ ...editingMilestone, approval_required: e.target.checked })}
//                     className="h-4 w-4 text-orange-600"
//                   />
//                   <label className="ml-2 text-sm">Requires Approval</label>
//                 </div>
//               </div>

//               <div className="mt-8 flex justify-end gap-3">
//                 <button
//                   onClick={() => setShowEditMilestoneForm(false)}
//                   className="px-5 py-2.5 border rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleUpdateMilestone}
//                   className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg"
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Add Task Modal */}
//         {showTaskForm && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">Add New Task</h3>
//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Milestone Name *
//                   </label>
//                   <input
//                     type="text"
//                     value={milestoneForm.name}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, name: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     placeholder="e.g. Design Phase Completion"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Sequence Number *
//                   </label>
//                   <input
//                     type="number"
//                     value={milestoneForm.sequence_no}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, sequence_no: e.target.value })
//                     }
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     min="1"
//                   />
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Planned Start
//                     </label>
//                     <input
//                       type="date"
//                       value={milestoneForm.planned_start}
//                       onChange={(e) =>
//                         setMilestoneForm({ ...milestoneForm, planned_start: e.target.value })
//                       }
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Planned End
//                     </label>
//                     <input
//                       type="date"
//                       value={milestoneForm.planned_end}
//                       onChange={(e) =>
//                         setMilestoneForm({ ...milestoneForm, planned_end: e.target.value })
//                       }
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                 </div>

//                 <div className="flex items-center">
//                   <input
//                     type="checkbox"
//                     checked={milestoneForm.approval_required}
//                     onChange={(e) =>
//                       setMilestoneForm({ ...milestoneForm, approval_required: e.target.checked })
//                     }
//                     className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
//                   />
//                   <label className="ml-2 text-sm text-gray-700 dark:text-gray-300">
//                     Requires Approval
//                   </label>
//                 </div>
//               </div>

//               <div className="mt-8 flex justify-end gap-3">
//                 <button
//                   onClick={() => setShowMilestoneForm(false)}
//                   className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleAddMilestone}
//                   className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg shadow-sm transition"
//                 >
//                   Create Milestone
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Quick Add Task Form - Modal style */}
//         {showTaskForm && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">Add New Task</h3>

//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Task Title *
//                   </label>
//                   <input
//                     type="text"
//                     value={taskForm.title}
//                     onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     placeholder="e.g. Create social media creatives for week 1"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Description
//                   </label>
//                   <textarea
//                     value={taskForm.description}
//                     onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
//                     rows={3}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Assign To
//                   </label>
//                   <select
//                     value={taskForm.assigned_to}
//                     onChange={(e) => setTaskForm({ ...taskForm, assigned_to: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                   >
//                     <option value="">Unassigned</option>
//                     {users.map((user) => (
//                       <option key={user.id} value={user.id}>
//                         {user.name} ({user.role?.name || 'Member'})
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Priority
//                     </label>
//                     <select
//                       value={taskForm.priority}
//                       onChange={(e) => setTaskForm({ ...taskForm, priority: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     >
//                       <option>Low</option>
//                       <option>Medium</option>
//                       <option>High</option>
//                       {/* <option>Urgent</option> */}
//                     </select>
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Due Date
//                     </label>
//                     <input
//                       type="date"
//                       value={taskForm.due_date}
//                       onChange={(e) => setTaskForm({ ...taskForm, due_date: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                     Initial Status
//                   </label>
//                   <select
//                     value={taskForm.status}
//                     onChange={(e) => setTaskForm({ ...taskForm, status: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//                   >
//                     <option>Pending</option>
//                     <option>In Progress</option>
//                     <option>Needs Approval</option>
//                   </select>
//                 </div>
//               </div>
//               <div>
//           <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//             Assign to Milestone
//           </label>
//           <select
//             value={taskForm.milestone_id || ''}
//             onChange={(e) => setTaskForm({ ...taskForm, milestone_id: e.target.value || null })}
//             className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
//           >
//             <option value="">— Unassigned / General —</option>
//             {project?.Milestones?.map(m => (
//               <option key={m.id} value={m.id}>
//                 {m.sequence_no}. {m.name} ({m.status})
//               </option>
//             ))}
//           </select>
//         </div>

            
//               <div className="mt-8 flex justify-end gap-3">
//                 <button onClick={() => setShowTaskForm(false)} className="px-5 py-2.5 border rounded-lg">
//                   Cancel
//                 </button>
//                 <button onClick={handleAddTask} className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg">
//                   Create Task
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Edit Task Modal */}
//         {/* {showEditTaskForm && editingTask && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">Edit Task</h3>

//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Title *</label>
//                   <input
//                     type="text"
//                     value={editingTask.title}
//                     onChange={(e) => setEditingTask({ ...editingTask, title: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium mb-1">Description</label>
//                   <textarea
//                     value={editingTask.description || ''}
//                     onChange={(e) => setEditingTask({ ...editingTask, description: e.target.value })}
//                     rows={3}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium mb-1">Assign To</label>
//                   <select
//                     value={editingTask.assigned_to || ''}
//                     onChange={(e) => setEditingTask({ ...editingTask, assigned_to: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option value="">Unassigned</option>
//                     {users.map((user) => (
//                       <option key={user.id} value={user.id}>
//                         {user.name} ({user.role?.name || 'Member'})
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium mb-1">Priority</label>
//                     <select
//                       value={editingTask.priority}
//                       onChange={(e) => setEditingTask({ ...editingTask, priority: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     >
//                       <option>Low</option>
//                       <option>Medium</option>
//                       <option>High</option>
//                     </select>
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium mb-1">Due Date</label>
//                     <input
//                       type="date"
//                       value={editingTask.due_date || ''}
//                       onChange={(e) => setEditingTask({ ...editingTask, due_date: e.target.value })}
//                       className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium mb-1">Status</label>
//                   <select
//                     value={editingTask.status}
//                     onChange={(e) => setEditingTask({ ...editingTask, status: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option>Pending</option>
//                     <option>In Progress</option>
//                     <option>Needs Approval</option>
//                     <option>Approved</option>
//                     <option>Completed</option>
//                   </select>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium mb-1">Assign to Milestone</label>
//                   <select
//                     value={editingTask.milestone_id || ''}
//                     onChange={(e) => setEditingTask({ ...editingTask, milestone_id: e.target.value || null })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option value="">— Unassigned / General —</option>
//                     {project?.Milestones?.map(m => (
//                       <option key={m.id} value={m.id}>
//                         {m.sequence_no}. {m.name} ({m.status})
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div className="mt-8 flex justify-end gap-3">
//                 <button onClick={() => setShowEditTaskForm(false)} className="px-5 py-2.5 border rounded-lg">
//                   Cancel
//                 </button>
//                 <button onClick={handleUpdateTask} className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg">
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>
//         )} */}

//         {/* Edit Team Member Modal */}
//         {showEditTeamMember && editingTeamMember && (
//           <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
//             <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full p-6">
//               <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">
//                 Edit Team Member
//               </h3>

//               <div className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium mb-1">Name (read-only)</label>
//                   <input
//                     type="text"
//                     value={editingTeamMember.member?.name || ''}
//                     disabled
//                     className="w-full px-4 py-2 border rounded-lg bg-gray-100 dark:bg-gray-700 dark:border-gray-600 cursor-not-allowed"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium mb-1">Role</label>
//                   <input
//                     type="text"
//                     value={editingTeamMember.role || 'Member'}
//                     onChange={(e) => setEditingTeamMember({ ...editingTeamMember, role: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium mb-1">Permission Level</label>
//                   <select
//                     value={editingTeamMember.permission_level || 'EDIT'}
//                     onChange={(e) => setEditingTeamMember({ ...editingTeamMember, permission_level: e.target.value })}
//                     className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                   >
//                     <option value="VIEW">VIEW</option>
//                     <option value="EDIT">EDIT</option>
//                     <option value="ADMIN">ADMIN</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="mt-8 flex justify-end gap-3">
//                 <button
//                   onClick={() => setShowEditTeamMember(false)}
//                   className="px-5 py-2.5 border rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleUpdateTeamMember}
//                   className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg"
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function StatCard({ icon, title, value, subtitle, className = "" }) {
//   return (
//     <div 
//       className={`
//         rounded-xl shadow-sm border p-5 sm:p-6
//         transition-all duration-200 hover:shadow
//         ${className}
//       `}
//     >
//       <div className="flex items-center gap-4">
//         <div className="flex-shrink-0">{icon}</div>
//         <div className="min-w-0">
//           <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
//             {title}
//           </p>
//           <p className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mt-1">
//             {value}
//           </p>
//           {subtitle && (
//             <p className="text-sm text-gray-600 dark:text-gray-400 mt-1.5">
//               {subtitle}
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }



// src/pages/Projects/ProjectDetails.jsx
import React, { useState, useEffect ,useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ArrowLeftIcon,
  PlusIcon,
  UsersIcon,
  ClipboardDocumentListIcon,
  CheckCircleIcon,
  ClockIcon,
  ExclamationTriangleIcon,PencilIcon,TrashIcon,
} from '@heroicons/react/24/outline';
import api from '../../utils/api';

const statusColors = {
  'Not Started': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  'In Progress': 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  'Awaiting Approval': 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
  'Completed': 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  'Approved': 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
  'Pending': 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
'Draft': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  'Active': 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  'Archived': 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300',
};

export default function ProjectDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [project, setProject] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);

  const [showMilestoneForm, setShowMilestoneForm] = useState(false);
  const [showTaskForm, setShowTaskForm] = useState(false);
const [showEditMilestoneForm, setShowEditMilestoneForm] = useState(false);
  const [editingMilestone, setEditingMilestone] = useState(null);
  const [milestoneForm, setMilestoneForm] = useState({
    name: '',
    sequence_no: '',
    planned_start: '',
    planned_end: '',
    approval_required: true,
  });

  const [taskForm, setTaskForm] = useState({
    title: '',
    description: '',
    assigned_to: '',
    priority: 'Medium',
    due_date: '',
    status: 'Pending',
    milestone_id: '',
  });

  useEffect(() => {
    loadData();
    loadUsers();
  }, [id]);

  const loadData = async () => {
    try {
      setLoading(true);
      const { data: projectRes } = await api.get(`/projects/${id}`);
      setProject(projectRes.project);

      const { data: dashRes } = await api.get(`/projects/${id}/dashboard`);
      setDashboardData(dashRes);
    } catch (err) {
      console.error(err);
      setError('Failed to load project details');
    } finally {
      setLoading(false);
    }
  };

  const loadUsers = async () => {
    try {
      const { data } = await api.get('/users');
      setUsers(data.users || []);
    } catch (err) {
      console.error('Failed to load users', err);
    }
  };
const handleEditMilestone = (milestone) => {
    setEditingMilestone({ ...milestone });
    setShowEditMilestoneForm(true);
  };

  const handleUpdateMilestone = async () => {
    if (!editingMilestone.name.trim()) return alert('Name is required');

    try {
      await api.put(`/milestones/${editingMilestone.id}`, {
        name: editingMilestone.name,
        sequence_no: editingMilestone.sequence_no,
        planned_start: editingMilestone.planned_start || null,
        planned_end: editingMilestone.planned_end || null,
        approval_required: editingMilestone.approval_required,
      });
      setShowEditMilestoneForm(false);
      setEditingMilestone(null);
      loadData();
      alert('Milestone updated successfully');
    } catch (err) {
      alert('Failed to update milestone');
    }
  };

  const handleDeleteMilestone = async (milestoneId) => {
    if (!window.confirm('Delete this milestone?')) return;
    try {
      await api.delete(`/milestones/${milestoneId}`);
      loadData();
      alert('Milestone deleted');
    } catch (err) {
      alert('Failed to delete milestone');
    }
  };
  const updateItemStatus = async (type, itemId, newStatus) => {
    try {
      const endpoint = type === 'milestone' ? `/milestones/${itemId}` : `/tasks/${itemId}`;
      await api.put(endpoint, { status: newStatus });
      await loadData();
    } catch (err) {
      console.error("Status update failed:", err);
      alert('Failed to update status');
    }
  };

  const handleAddMilestone = async () => {
    if (!milestoneForm.name.trim() || !milestoneForm.sequence_no) {
      alert('Name and sequence number are required');
      return;
    }
    try {
      await api.post(`/projects/${id}/milestones`, milestoneForm);
      setShowMilestoneForm(false);
      setMilestoneForm({
        name: '',
        sequence_no: (project?.Milestones?.length || 0) + 1,
        planned_start: '',
        planned_end: '',
        approval_required: true,
      });
      loadData();
    } catch (err) {
      alert('Failed to create milestone');
    }
  };

  const handleAddTask = async () => {
    if (!taskForm.title.trim()) return alert('Task title is required');
    try {
      await api.post('/tasks', {
        ...taskForm,
        project_id: Number(id),
        milestone_id: taskForm.milestone_id || null,
      });
      setShowTaskForm(false);
      setTaskForm({
        title: '',
        description: '',
        assigned_to: '',
        priority: 'Medium',
        due_date: '',
        status: 'Pending',
        milestone_id: '',
      });
      loadData();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to create task');
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  if (error || !project) return <div className="text-red-600 text-center min-h-screen flex items-center justify-center">{error || 'Project not found'}</div>;

  const {
    name,
    project_uid,
    project_type,
    status: projStatus,
    start_date,
    expected_end_date,
    overall_progress = 0,
    total_milestones = 0,
    completed_milestones = 0,
    total_tasks = 0,
    ProjectTeams = [],
    Milestones = [],
    Tasks = [],
  } = project;

  const { stats } = dashboardData || {};

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8 gap-4">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate('/projects')} className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800">
              <ArrowLeftIcon className="w-6 h-6 text-gray-600 dark:text-gray-400" />
            </button>
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 dark:text-orange-500">{name}</h1>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {project_uid} • {project_type || 'Other'} • {projStatus || 'Active'}
              </p>
            </div>
          </div>

          <div className="flex gap-3 flex-wrap">
            <button
              onClick={() => setShowMilestoneForm(true)}
              className="flex items-center gap-2 px-4 py-2.5 bg-black hover:bg-gray-900 text-white text-sm font-medium rounded-lg shadow-md transition"
            >
              <PlusIcon className="w-4 h-4" /> Add Milestone
            </button>
            <button
              onClick={() => setShowTaskForm(true)}
              className="flex items-center gap-2 px-4 py-2.5 bg-black hover:bg-gray-900 text-white text-sm font-medium rounded-lg shadow-md transition"
            >
              <PlusIcon className="w-4 h-4" /> Add Task
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-10">
          <StatCard
            icon={<CheckCircleIcon className="h-8 w-8 text-emerald-600" />}
            title="Overall Progress"
            value={`${overall_progress || 0}%`}
            className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
          />

          <StatCard
            icon={<ClipboardDocumentListIcon className="h-8 w-8 text-blue-600" />}
            title="Milestones"
            value={`${completed_milestones || 0}/${total_milestones || 0}`}
            subtitle={`${Math.round((completed_milestones / total_milestones) * 100 || 0)}% complete`}
            className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
          />

          <StatCard
            icon={<ClockIcon className="h-8 w-8 text-amber-600" />}
            title="Tasks"
            value={total_tasks || 0}
            subtitle={`${stats?.tasks?.overdue || 0} overdue`}
            className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
          />

          <StatCard
            icon={
              <ExclamationTriangleIcon 
                className={`h-8 w-8 ${stats?.pendingApprovals > 0 ? 'text-rose-600' : 'text-gray-600'}`} 
              />
            }
            title="Pending Approvals"
            value={stats?.pendingApprovals || 0}
            subtitle={stats?.pendingApprovals > 0 ? "Action required" : "All clear"}
            className="bg-gray-200 hover:bg-gray-300 dark:bg-gray-800 dark:hover:bg-gray-700 border-gray-300 dark:border-gray-600 transition-colors"
          />
        </div>

        {/* Team Members – no edit/delete */}
        <div className="bg-gray-50 dark:bg-gray-900 rounded-xl shadow-lg p-6 mb-10 border border-gray-200 dark:border-gray-700">
          <h3 className="text-xl font-semibold mb-6 flex items-center gap-3 text-gray-900 dark:text-gray-100">
            <UsersIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
            Team Members ({ProjectTeams.length})
          </h3>

          {ProjectTeams.length === 0 ? (
            <p className="text-center py-8 text-gray-500 dark:text-gray-400">No team members assigned yet</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {ProjectTeams.map((member) => (
                <div
                  key={member.id}
                  className="flex items-center gap-4 p-4 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm"
                >
                  <div className="w-12 h-12 rounded-full bg-orange-100 dark:bg-orange-900/40 flex items-center justify-center text-xl font-bold text-orange-700 dark:text-orange-300 border border-orange-200">
                    {member.member?.name?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-gray-900 dark:text-gray-100 truncate">{member.member?.name}</p>
                    <p className="text-sm text-gray-600 dark:text-gray-400">{member.role || 'Member'}</p>
                    <p className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400 mt-1">
                      {member.permission_level || '—'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Milestones – no actions column */}
        {/* <div className="bg-white dark:bg-gray-900 rounded-xl shadow overflow-hidden mb-10 border border-gray-200 dark:border-gray-700">
          <div className="p-6 border-b bg-gray-100 dark:bg-gray-800">
            <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-gray-100">
              <ClipboardDocumentListIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
              Milestones ({total_milestones})
            </h2>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 table-fixed">
              <thead className="bg-gray-50 dark:bg-gray-800/70">
                <tr>
                  <th className="w-5/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    NAME
                  </th>
                  <th className="w-4/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    PLANNED DATES
                  </th>
                  <th className="w-3/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    STATUS
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
                {Milestones.length === 0 ? (
                  <tr>
                    <td colSpan={3} className="px-5 py-12 text-center text-gray-500 dark:text-gray-400">
                      No milestones created yet
                    </td>
                  </tr>
                ) : (
                  Milestones.map((m) => (
                    <tr key={m.id} className="hover:bg-orange-50/30 dark:hover:bg-orange-950/20">
                      <td className="px-5 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">{m.name}</td>
                      <td className="px-5 py-4 text-sm text-gray-600 dark:text-gray-400">
                        {m.planned_start || '—'} → {m.planned_end || '—'}
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-2">
                          <span className={`px-2.5 py-0.5 text-xs font-medium rounded-full ${statusColors[m.status] || 'bg-gray-200'}`}>
                            {m.status}
                          </span>
                          <select
                            value={m.status}
                            onChange={(e) => updateItemStatus('milestone', m.id, e.target.value)}
                            className="text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-800 min-w-[110px]"
                          >
                            <option>Not Started</option>
                            <option>In Progress</option>
                            <option>Awaiting Approval</option>
                            <option>Completed</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div> */}
        {/* Milestones Section */}
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow overflow-hidden mb-10 border border-gray-200 dark:border-gray-700">
          <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center bg-gray-100 dark:bg-gray-800">
            <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-gray-100">
              <ClipboardDocumentListIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
              Milestones ({total_milestones})
            </h2>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-800/70">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    Name
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    Planned Dates
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
                {Milestones.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400 font-medium">
                      No milestones created yet
                    </td>
                  </tr>
                ) : (
                  Milestones.map((m) => (
                    <tr 
                      key={m.id} 
                      className="hover:bg-orange-50/40 dark:hover:bg-orange-950/20 transition-colors duration-150"
                    >
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">
                        {m.name}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                        {m.planned_start || '—'} → {m.planned_end || '—'}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <span
                            className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                              m.status === 'Completed' 
                                ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'
                                : m.status === 'In Progress' 
                                ? 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300'
                                : m.status === 'Awaiting Approval' 
                                ? 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300'
                                : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
                            }`}
                          >
                            {m.status}
                          </span>

                          <select
                            value={m.status}
                            onChange={(e) => updateItemStatus('milestone', m.id, e.target.value)}
                            className="text-sm border border-gray-300 dark:border-gray-600 rounded px-3 py-1.5 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 focus:ring-opacity-50 hover:border-orange-400 transition-colors"
                          >
                            <option>Not Started</option>
                            <option>In Progress</option>
                            <option>Awaiting Approval</option>
                            <option>Completed</option>
                          </select>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                        <div className="flex items-center justify-center gap-4">
                          <button 
                            onClick={() => handleEditMilestone(m)}
                            className="text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 transition-colors"
                            title="Edit milestone"
                          >
                            <PencilIcon className="w-5 h-5" />
                          </button>
                          <button 
                            onClick={() => handleDeleteMilestone(m.id)}
                            className="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors"
                            title="Delete milestone"
                          >
                            <TrashIcon className="w-5 h-5" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Tasks – no actions column */}
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow overflow-hidden border border-gray-200 dark:border-gray-700">
          <div className="p-6 border-b bg-gray-100 dark:bg-gray-800">
            <h2 className="text-xl font-bold flex items-center gap-3 text-gray-900 dark:text-gray-100">
              <CheckCircleIcon className="w-6 h-6 text-orange-600 dark:text-orange-500" />
              Tasks ({total_tasks})
            </h2>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 table-fixed">
              <thead className="bg-gray-50 dark:bg-gray-800/70">
                <tr>
                  <th className="w-4/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    TITLE
                  </th>
                  <th className="w-3/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    ASSIGNEE
                  </th>
                  <th className="w-2/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    PRIORITY
                  </th>
                  <th className="w-2/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    DUE DATE
                  </th>
                  <th className="w-3/12 px-5 py-4 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    STATUS
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
                {Tasks.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="px-5 py-12 text-center text-gray-500 dark:text-gray-400">
                      No tasks created yet
                    </td>
                  </tr>
                ) : (
                  Tasks.map((t) => (
                    <tr key={t.id} className="hover:bg-orange-50/30 dark:hover:bg-orange-950/20">
                      <td className="px-5 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">{t.title}</td>
                      <td className="px-5 py-4 text-sm text-gray-700 dark:text-gray-300">
                        {t.assignee?.name || 'Unassigned'}
                      </td>
                      <td className="px-5 py-4">
                        <span className={`px-2.5 py-0.5 text-xs font-medium rounded-full ${t.priority === 'High' ? 'bg-orange-100 text-orange-800' : 'bg-amber-100 text-amber-800'}`}>
                          {t.priority}
                        </span>
                      </td>
                      <td className="px-5 py-4 text-sm text-gray-600 dark:text-gray-400">
                        {t.due_date || '—'}
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex items-center gap-2">
                          <span className={`px-2.5 py-0.5 text-xs font-medium rounded-full ${statusColors[t.status] || 'bg-gray-200'}`}>
                            {t.status}
                          </span>
                          <select
                            value={t.status}
                            onChange={(e) => updateItemStatus('task', t.id, e.target.value)}
                            className="text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-800 min-w-[110px]"
                          >
                            <option>Pending</option>
                            <option>In Progress</option>
                            <option>Needs Approval</option>
                            <option>Approved</option>
                            <option>Completed</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Add Milestone Modal – unchanged */}
        {showMilestoneForm && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
           <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
              <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">
                Add New Milestone
              </h3>
              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Milestone Name *
                  </label>
                  <input
                    type="text"
                    value={milestoneForm.name}
                    onChange={(e) => setMilestoneForm({ ...milestoneForm, name: e.target.value })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                    placeholder="e.g. Design Phase Completion"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Phase No *
                  </label>
                  <input
                    type="number"
                    value={milestoneForm.sequence_no}
                    onChange={(e) => setMilestoneForm({ ...milestoneForm, sequence_no: e.target.value })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                    min="1"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Planned Start
                    </label>
                    <input
                      type="date"
                      value={milestoneForm.planned_start}
                      onChange={(e) => setMilestoneForm({ ...milestoneForm, planned_start: e.target.value })}
                      className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Planned End
                    </label>
                    <input
                      type="date"
                      value={milestoneForm.planned_end}
                      onChange={(e) => setMilestoneForm({ ...milestoneForm, planned_end: e.target.value })}
                      className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                  </div>
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={milestoneForm.approval_required}
                    onChange={(e) => setMilestoneForm({ ...milestoneForm, approval_required: e.target.checked })}
                    className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                  />
                  <label className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                    Requires Approval
                  </label>
                </div>
              </div>

              <div className="mt-8 flex justify-end gap-3">
                <button onClick={() => setShowMilestoneForm(false)} className="px-5 py-2.5 border rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100">
                  Cancel
                </button>
                <button onClick={handleAddMilestone} className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg">
                  Create Milestone
                </button>
              </div>
            </div>
          </div>
        )}
{/* Edit Milestone Modal */}
        {showEditMilestoneForm && editingMilestone && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
              <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">
                Edit Milestone
              </h3>

              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-medium mb-1">Name *</label>
                  <input
                    type="text"
                    value={editingMilestone.name}
                    onChange={(e) => setEditingMilestone({ ...editingMilestone, name: e.target.value })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Sequence Number *</label>
                  <input
                    type="number"
                    value={editingMilestone.sequence_no}
                    onChange={(e) => setEditingMilestone({ ...editingMilestone, sequence_no: Number(e.target.value) })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    min="1"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Planned Start</label>
                    <input
                      type="date"
                      value={editingMilestone.planned_start || ''}
                      onChange={(e) => setEditingMilestone({ ...editingMilestone, planned_start: e.target.value })}
                      className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Planned End</label>
                    <input
                      type="date"
                      value={editingMilestone.planned_end || ''}
                      onChange={(e) => setEditingMilestone({ ...editingMilestone, planned_end: e.target.value })}
                      className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                  </div>
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={editingMilestone.approval_required}
                    onChange={(e) => setEditingMilestone({ ...editingMilestone, approval_required: e.target.checked })}
                    className="h-4 w-4 text-orange-600"
                  />
                  <label className="ml-2 text-sm">Requires Approval</label>
                </div>
              </div>

              <div className="mt-8 flex justify-end gap-3">
                <button
                  onClick={() => setShowEditMilestoneForm(false)}
                  className="px-5 py-2.5 border rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={handleUpdateMilestone}
                  className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Add Task Modal – unchanged */}
        {showTaskForm && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
           <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-lg w-full p-6">
              <h3 className="text-xl font-bold mb-5 text-gray-900 dark:text-white">Add New Task</h3>
              <div className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Task Title *
                  </label>
                  <input
                    type="text"
                    value={taskForm.title}
                    onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                    placeholder="e.g. Create social media creatives for week 1"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Description
                  </label>
                  <textarea
                    value={taskForm.description}
                    onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
                    rows={3}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Assign To
                  </label>
                  <select
                    value={taskForm.assigned_to}
                    onChange={(e) => setTaskForm({ ...taskForm, assigned_to: e.target.value })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                  >
                    <option value="">Unassigned</option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name} ({user.role?.name || 'Member'})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Priority
                    </label>
                    <select
                      value={taskForm.priority}
                      onChange={(e) => setTaskForm({ ...taskForm, priority: e.target.value })}
                      className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                    >
                      <option>Low</option>
                      <option>Medium</option>
                      <option>High</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Due Date
                    </label>
                    <input
                      type="date"
                      value={taskForm.due_date}
                      onChange={(e) => setTaskForm({ ...taskForm, due_date: e.target.value })}
                      className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Initial Status
                  </label>
                  <select
                    value={taskForm.status}
                    onChange={(e) => setTaskForm({ ...taskForm, status: e.target.value })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                  >
                    <option>Pending</option>
                    <option>In Progress</option>
                    <option>Needs Approval</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Assign to Milestone
                  </label>
                  <select
                    value={taskForm.milestone_id || ''}
                    onChange={(e) => setTaskForm({ ...taskForm, milestone_id: e.target.value || null })}
                    className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-orange-500 focus:border-orange-500"
                  >
                    <option value="">— Unassigned / General —</option>
                    {project?.Milestones?.map(m => (
                      <option key={m.id} value={m.id}>
                        {m.sequence_no}. {m.name} ({m.status})
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mt-8 flex justify-end gap-3">
                <button onClick={() => setShowTaskForm(false)} className="px-5 py-2.5 border rounded-lg">
                  Cancel
                </button>
                <button onClick={handleAddTask} className="px-6 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-lg">
                  Create Task
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

// StatCard component (unchanged)
function StatCard({ icon, title, value, subtitle, className = "" }) {
  return (
    <div className={`rounded-xl shadow-sm border p-5 sm:p-6 transition-all hover:shadow ${className}`}>
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0">{icon}</div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</p>
          <p className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mt-1">{value}</p>
          {subtitle && <p className="text-sm text-gray-600 dark:text-gray-400 mt-1.5">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
}

